import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { RefreshCw } from 'lucide-react';

const RefundPolicyPage = () => {
  return (
    <div className="page legal-page">
      <Header onEnrollClick={() => window.location.href = '/pricing'} />
      
      <main className="page-content">
        <section className="page-hero legal-hero">
          <div className="container">
            <RefreshCw className="legal-icon" />
            <h1 className="page-title">Refund Policy</h1>
            <p className="page-subtitle">Last updated: January 2026</p>
          </div>
        </section>

        <section className="legal-content">
          <div className="container">
            <div className="legal-document">
              <div className="highlight-box">
                <h3>30-Day Money-Back Guarantee</h3>
                <p>
                  We're confident in the quality of our courses. If you're not completely satisfied, 
                  we offer a full refund within 30 days of purchase — no questions asked.
                </p>
              </div>

              <h2>1. Eligibility for Refund</h2>
              <p>You are eligible for a full refund if:</p>
              <ul>
                <li>Your refund request is made within 30 days of the original purchase date</li>
                <li>You have not completed more than 30% of the course content</li>
                <li>You have not received a certificate of completion</li>
                <li>This is your first refund request for this course</li>
              </ul>

              <h2>2. How to Request a Refund</h2>
              <p>To request a refund:</p>
              <ol>
                <li>Email us at refunds@wsafeaiml.com with your order details</li>
                <li>Or use our <a href="/contact">Contact Form</a> and select "Billing & Payments"</li>
                <li>Include your registered email address and order number</li>
                <li>Briefly explain why you'd like a refund (optional but helpful)</li>
              </ol>

              <h2>3. Refund Processing</h2>
              <ul>
                <li><strong>Processing Time:</strong> Refunds are processed within 5-7 business days</li>
                <li><strong>Payment Method:</strong> Refunds are issued to the original payment method</li>
                <li><strong>Confirmation:</strong> You'll receive an email confirmation once processed</li>
                <li><strong>Bank Processing:</strong> Allow 5-10 additional days for the refund to appear in your account</li>
              </ul>

              <h2>4. Non-Refundable Items</h2>
              <p>The following are not eligible for refunds:</p>
              <ul>
                <li>Courses purchased more than 30 days ago</li>
                <li>Courses where more than 30% content has been accessed</li>
                <li>Completed courses with issued certificates</li>
                <li>Bundle discounts after partial refund</li>
                <li>1-on-1 mentoring sessions that have been used</li>
              </ul>

              <h2>5. Premium Plan Specifics</h2>
              <p>For Premium Plan purchases:</p>
              <ul>
                <li>Full refund available within 30 days if no mentoring sessions used</li>
                <li>Partial refund (course portion only) if mentoring sessions have been scheduled</li>
                <li>No refund for used mentoring sessions</li>
              </ul>

              <h2>6. Course Access After Refund</h2>
              <p>
                Upon refund approval, your access to the course will be revoked immediately. 
                Any downloaded materials should be deleted from your devices.
              </p>

              <h2>7. Disputes</h2>
              <p>
                If you're unsatisfied with a refund decision, please contact our support team. 
                We're committed to fair resolution of all disputes.
              </p>

              <h2>8. Changes to This Policy</h2>
              <p>
                We reserve the right to modify this refund policy at any time. Changes will not 
                affect purchases made before the modification date.
              </p>

              <h2>9. Contact Us</h2>
              <p>For refund inquiries:</p>
              <ul>
                <li>Email: refunds@wsafeaiml.com</li>
                <li>Response time: Within 24 hours</li>
                <li>Contact Form: <a href="/contact">Contact Page</a></li>
              </ul>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default RefundPolicyPage;
